import axios from "axios";
import setUpAxios from "../setUpAxios";  // Assuming it's imported like this
import { baseURL } from "../config";  // Adjust based on the correct path

// Function to handle form submission
export const submitFormData = async (endpoint, formData) => {
  try {
    // Setup axios if needed (you can move this logic elsewhere if preferred)
    setUpAxios();

    const response = await axios.post(`${baseURL}${endpoint}`, formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("Response data:", response.data); // For debugging
    return response.data;
  } catch (error) {
    throw error; // Will be caught in the component's try/catch block
  }
};
